import Vue from 'vue';
import vueVimeoPlayer from 'vue-vimeo-player';

Vue.use(vueVimeoPlayer);
